<template>
  <div class="resident-warpper">
    <div class="bg-white">
      <div class="flex align-center justify-between">
        <div class="flex-sub margin-right">
          <div class="flex align-center justify-between">
            <div class="flex align-center margin-right-sm margin-bottom-xs basis-sm">
              <span>姓<i style="padding-left: 14px;"></i>名：</span>
              <el-input v-model="name" placeholder="请输入姓名" class="flex-sub"></el-input>
            </div>
            <div class="flex align-center margin-right-sm margin-bottom-xs basis-sm">
              <span>手机号：</span>
              <el-input v-model="phone" placeholder="请输入手机号" class="flex-sub"></el-input>
            </div>
          </div>

          <fiveLevel @upFive="upFive"/>
        </div>
        <el-button type="primary" @click="hanldSearch">搜索</el-button>
      </div>

      <div class="flex align-center justify-between margin-tb-sm">
        <div>
          共{{ total }}条数据
        </div>
        <div>
          <el-button
            size="small"
            type="warning"
            @click="exportServedPeople"
          >导出服务对象信息
          </el-button>
        </div>
      </div>

      <el-table
        :data="residentList"
        header-row-class-name="table-header"
        row-class-name="table-row"
        alig="center"
        border
        style="width: 100%"
      >
        <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
<!--        <el-table-column label="社区" prop="xiangmu_name"></el-table-column>-->
        <el-table-column label="小区" prop="xiaoqu_name"></el-table-column>
        <el-table-column label="联系人" prop="guanjia_name"></el-table-column>
        <el-table-column label="居民姓名" prop="name"></el-table-column>
        <el-table-column label="手机号" prop="phone"></el-table-column>
        <el-table-column label="楼门户">
          <template slot-scope="scope">
            <div>
              {{ scope.row.building_name }}-{{ scope.row.element_name }}-{{ scope.row.room_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="完成服务次数" prop="service_num"></el-table-column>
        <el-table-column label="剩余积分" prop="integral"></el-table-column>
        <el-table-column label="操作" >
          <template slot-scope="scope">
            <div class="table-operate">
              <el-button
                size="small"
                type="primary"
                @click="detailItem(scope.row.jumin_id)"
              >查看
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="residentList.length > 0"
        class="page-all"
        background
        @current-change="getResidentList"
        :current-page.sync="page"
        :page-size="limit"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>

import {commentList, filesCN,  serviceState} from "@/utils/utils";
import fiveLevel from '@/components/five-level'
import {exportServedPeople, getServedPeople} from "@/api/weilao";

export default {
  name: "server-pople",
  data() {
    return {

      name: '',
      phone: '',
      service_type: '',
      service_state: '',
      comment: '',
      relation: 0,
      project: 0,
      community: 0,
      building: 0,
      unit: 0,
      room: 0,
      page: 1,
      limit: 10,
      total: 0,
      residentList: [],
      setId: 0,
      setItem: {},

    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  created() {
    this.$emit("setIndex", this.$route.path, "双暖为老 / 服务对象", false);
    this.getResidentList()
  },
  components: {
    fiveLevel,
  },
  methods: {
    //  居民导出
    async exportServedPeople(){
      let _state = await exportServedPeople(
        this.name,
        this.phone,
        this.project,
        this.community,
        this.building,
        this.unit,
        this.room,
      )
      let blob = _state.data
      var downloadElement = document.createElement('a');
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.setAttribute('download', '被服务居民数据.xls');
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    //  备注
    detailItem(id) {
      this.$router.push('/home/server-pople-detail/' + id)
    },


    //  搜索
    hanldSearch() {
      this.page = 1
      this.getResidentList()
    },

    //  获取居民列表
    async getResidentList() {
      let _data = await getServedPeople(
        this.name,
        this.phone,
        this.project,
        this.community,
        this.building,
        this.unit,
        this.room,
        this.page,
        this.limit,
      )
      this.residentList = _data.data
      this.total = _data.total_number
    },
    //  同步更新五级联动
    upFive(val) {
      this.project = val.project
      this.community = val.community
      this.building = val.building
      this.unit = val.unit
      this.room = val.room
    }
  },
  filters: {
    state(val) {
      return filesCN(Number(val), serviceState)
    },
    comment(val) {
      return filesCN(Number(val), commentList)
    }
  },
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
